import React, { useState, useEffect } from 'react';
import { ArrowRight, X } from 'lucide-react';

const PackageNudge = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;

    const handleScroll = () => {
      const packagesEl = document.getElementById('packages');
      if (!packagesEl) return;

      const rect = packagesEl.getBoundingClientRect();
      // Show when user has scrolled ~60% through the packages section
      const triggerPoint = rect.top + rect.height * 0.4;
      if (triggerPoint < 0 && !dismissed) {
        setVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [dismissed]);

  if (!visible || dismissed) return null;

  return (
    <div
      data-testid="package-nudge"
      className="fixed top-1/2 -translate-y-1/2 right-0 z-30 hidden lg:block animate-fade-up"
    >
      <div className="bg-white rounded-l-xl shadow-2xl p-5 max-w-xs border-l-4 border-gold relative">
        <button
          onClick={() => setDismissed(true)}
          className="absolute top-2 right-2 text-gray-300 hover:text-gray-500"
        >
          <X className="w-4 h-4" />
        </button>
        <p className="text-gray-900 text-sm font-bold mb-1">87% of couples upgrade</p>
        <p className="text-gray-500 text-xs mb-3">
          Most couples choose the Video & Photo Collection for complete coverage of their day.
        </p>
        <button
          onClick={() => {
            setDismissed(true);
            document.querySelector('[data-testid="package-video-photo-collection"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }}
          className="text-gold hover:text-gold-light text-xs font-bold flex items-center gap-1 transition-colors"
        >
          See what's included <ArrowRight className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
};

export default PackageNudge;
